import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface UnreadIncidentsState {
    unreadIncidents: number,
    lastIncidentAssignment?: string
}

const initialState: UnreadIncidentsState = {
    unreadIncidents: 0
};

const unreadIncidentsSlice = createSlice({
    name: 'unreadIncidents',
    initialState,
    reducers: {
        unreadIncidentsSet: (state, action: PayloadAction<UnreadIncidentsState>) => {
            return action.payload;
        }
    }
});

export const {unreadIncidentsSet} = unreadIncidentsSlice.actions;
export default unreadIncidentsSlice.reducer;
